// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1ii4I","content":"LayoutSettings_content__M3T41"};